import { PurchaseOrderStatusEnum } from "@altertec_gparn/lib";

export class PurchaseOrderSummaryDto {
  id: string;
  code: string;
  status?: PurchaseOrderStatusEnum;

  toString(): string {
    return this.code;
  }
}
